<template>
  <button-link v-show="hasPerms" size="small" :to="link">
    <slot>{{ buttonText }}</slot>
  </button-link>
</template>

<script>
  import ButtonLink from '@c/ButtonLink'
  import Mixin from './Mixin'
  import { can } from '@/libs/utils'

  export default {
    name: 'RowToEdit',
    props: {
      buttonText: {
        type: String,
        default: '编辑',
      },
    },
    components: {
      ButtonLink,
    },
    mixins: [Mixin],
    data() {
      return {
        identify: undefined,
        hasPerms: false
      }
    },
    computed: {
      link() {
        this.checkResourceName()
        return `/${this.resource}/${this.identify}/edit`
      },
    },
    mounted() {
      this.setIdentify();
      this.hasPerms = can(this.resource + '.edit');
    }
  }
</script>
